// @ flow
import _debug from 'debug';
import {
  GET_GEOLOCATION,
  setGeolocation,
  getlocationFailed
} from '../stores/geolocation';
import type { Store } from '../stores/reducer';
import { getGeolocation } from '../helpers/geolocation';
import { geolocationToLatLng, geocodeLatLng } from '../helpers/maps';

const debug = _debug('jp:middleware:geolocation');

type Action = {| type: typeof GET_GEOLOCATION |};

const geolocationMiddleware = (store: Store) => (next: Function) => (
  action: Action
): any => {
  switch (action.type) {
    case GET_GEOLOCATION: {
      debug(GET_GEOLOCATION);

      getGeolocation({ maximumAge: 120000 })
        .then(geolocationToLatLng)
        .then(geocodeLatLng)
        .then(geocoderResult => {
          const lat = geocoderResult[0].geometry.location.lat();
          const lng = geocoderResult[0].geometry.location.lng();
          const address = geocoderResult[0].formatted_address;

          store.dispatch(setGeolocation(address, { lat, lng }));
        })
        .catch(() => {
          store.dispatch(getlocationFailed());
        });

      break;
    }

    default:
      break;
  }

  return next(action);
};

export default geolocationMiddleware;
